module.exports = __webpack_public_path__ + "img/w3_circle_list_image_white.9d80f56a.png";